import InvitationDialog from './_InvitationDialog';

export default InvitationDialog;
